import { LocationItem } from './LocationItem';

export default () => {
  document.addEventListener('locationsInRangeDidUpdate', (e) => {
    const data = e.detail;

    const locationsInRangeParentWrapper = document.querySelector('[data-store-locator-locations]');
    if (!locationsInRangeParentWrapper) return;

    document.querySelector('[data-location-count]').innerHTML = data.locations.length;
    document.querySelector('[data-location-range]').innerHTML = data.range;

    // Sort locations by distance
    const sortedLocations = data.locations.sort((a, b) => a.properties.distance - b.properties.distance);

    document.querySelector('[data-store-locator-results]').classList.remove('StoreLocator__results--loading');

    const locationsInRangeWrapper = document.createElement('div');
    locationsInRangeWrapper.classList.add('LocationsInRange');

    // clear previous results
    locationsInRangeParentWrapper.innerHTML = '';

    // Check if thereare no locations in range
    if (!sortedLocations.length) {
      const noResultsPod = document.createElement('div');
      noResultsPod.classList.add('LocationsInRange__no-results');
      noResultsPod.textContent = 'Sorry, no results';
      locationsInRangeParentWrapper.appendChild(noResultsPod);
      return;
    }

    // Populate the locations in the wrapper
    sortedLocations.forEach((location, i) => {
      const locationItem = new LocationItem(location, i);
      locationsInRangeWrapper.appendChild(locationItem.node);
    });

    locationsInRangeParentWrapper.appendChild(locationsInRangeWrapper);
  });
};
